import * as React from 'react'

import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import MarkdownViewer from 'components/atomic/organisms/markdown-viewer'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

const Description = ({ description }: { description: string }) => {
    const { t }: I18n = useTranslation()

    return (
        <div>
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                <Icon fontSize="small" color="primary" name="helpOutline" />
                <Text sx={{ textTransform: 'uppercase', fontWeight: 'bold' }} color="primary">
                    {t('path:descriptionSection.title')}
                </Text>
            </Stack>
            <MarkdownViewer>{description}</MarkdownViewer>
        </div>
    )
}

export default Description
